import { set } from 'lodash-es';

import { RegisterService } from 'types/services/base';
import { Services } from 'types/services/interface';

export const services = {} as Services;

export const registerService: typeof RegisterService<unknown> = (name, fn) => {
  set(services, name, fn);
};

export default () => {
  registerService('registerService', registerService);
};
